// run on specific page
if (window.location.pathname.startsWith('/products/cravloft-aroma-refill-subscription-for-existing-machine-owners-1')) {
  // work to do on purchase button elements load
  const waitForSls = () => {
    const boxes = document.querySelectorAll('.sls-purchase-options-container > div');

    // check elements exist
    if (boxes.length >= 2) {
      // hide desired box
      boxes[0].style.display = 'none';
      // select desired box
      boxes[1].click();
      return true;
    }
    return false;
  };

  // try just in case already loaded
  waitForSls();

  // create observer
  const observer = new MutationObserver(() => {
    // call and check
    if (waitForSls()) {
      // remove when done
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
